module.exports = __webpack_public_path__ + "img/gameshow6.ca0d6254.svg";